var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-container',[_c('vs-stack',{attrs:{"items":"center","justify":"between","padding-y":"xs","horizontal":""}},[_c('logo',{attrs:{"width":{ all: '2xl', xl: 'auto' }}}),_vm._v(" "),_c('menu-actions')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }